import React, { useState, useEffect } from 'react';

// A URL da sua API. Assumindo que o public_site/server.js está rodando na porta 3005.
const API_URL = 'http://localhost:3005';

const ConfiguradorSite = () => {
  const [cliente, setCliente] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // TODO: Precisamos de um ID de cliente para buscar. Por enquanto, vamos usar um fixo.
  const CLIENTE_ID_EXEMPLO = 'ff41c642-755e-4d66-8603-9c73487ef5b5'; // ID do 'Hotel teste' do seu clientes.json

  useEffect(() => {
    const fetchCliente = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_URL}/api/clientes/${CLIENTE_ID_EXEMPLO}`);
        if (!response.ok) {
          throw new Error('Não foi possível buscar os dados do cliente.');
        }
        const data = await response.json();
        setCliente(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCliente();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCliente(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/api/clientes/${CLIENTE_ID_EXEMPLO}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cliente),
      });

      if (!response.ok) {
        throw new Error('Falha ao atualizar os dados.');
      }

      alert('Dados atualizados com sucesso!');
    } catch (err) {
      alert(err.message);
    }
  };

  if (loading) return <div>Carregando configurador...</div>;
  if (error) return <div>Erro: {error}</div>;
  if (!cliente) return <div>Nenhum cliente encontrado.</div>;

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Configurador do Site</h1>
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md">
        
        <div className="mb-4">
          <label htmlFor="nome" className="block text-gray-700 font-bold mb-2">Nome do Hotel</label>
          <input 
            type="text" 
            id="nome" 
            name="nome"
            value={cliente.nome || ''}
            onChange={handleInputChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>

        <div className="mb-4">
          <label htmlFor="dominio" className="block text-gray-700 font-bold mb-2">Domínio</label>
          <input 
            type="text" 
            id="dominio" 
            name="dominio"
            value={cliente.dominio || ''}
            onChange={handleInputChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>

        {/* Adicione outros campos aqui conforme necessário */}
        {/* Ex: Fotos, Descrições, etc. */}

        <div className="flex items-center justify-between">
          <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
            Salvar Alterações
          </button>
        </div>
      </form>
    </div>
  );
};

export default ConfiguradorSite;
